<template>
	<span class="action-tooltip" v-bind:class="{
		'action-tooltip--open' : isVisible,
		'action-tooltip--open-on-hover' : visibleOnHover
	}">
		<div @click="toggleState">
			<slot name="icon">
				<router-link v-if="defaultRoute" :to="{ name: defaultRoute, params: defaultRouteParams}">
					<span class="action-tooltip__action fonticon fonticon--action"></span>
				</router-link>
				<span v-else class="action-tooltip__action fonticon fonticon--action"></span>
			</slot>
		</div>
		<div class="action-tooltip__tooltip" v-bind:style="{
			transform: 'translateX('+ (-offset) +'%)',
		}">
			<div class="action-tooltip__tooltip-items">
				<slot></slot>
			</div>
		</div>
	</span>
</template>

<script>

export default {
	name: 'ActionTooltip',
	components: {
	},
	data () {
		return {
			isVisible: null
		}
	},
	props: {
		defaultRoute: String,
		defaultRouteParams: Object,
		offset: {
			type: Number,
			default: 50
		},
		visibleOnLoad: {
			type: Boolean,
			default: false
		},
		visibleOnHover: {
			type: Boolean,
			default: true
		},
	},
	computed: {
	},
	created: function()
	{
	},
	mounted: function()
	{
		var self = this;
		self.isVisible = self.visibleOnLoad;
	},
	methods: {
		toggleState()
		{
			var self = this;
			self.isVisible = !self.isVisible;
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".action-tooltip";
	#{$c}
	{
		position: relative;
		display: inline-block;
		user-select: none;

		&:before
		{
			position: absolute;
			top: 100%;
			left: 50%;
			margin-top: 4px;
			margin-left: -4px;
			content: "";
			display: none;
			width: 0;
			height: 0;
			border-style: solid;
			border-width: 0 4px 5px 4px;
			border-color: transparent transparent palette(font) transparent;
		}

		&--open:before,
		&--open-on-hover:hover:before
		{
			display: block;
		}

		&__action
		{
			font-size: rem(32);
			@include css-variables
			{
				transition: color calc(1s * #{var(base-trans-speed)});
			}

			:hover > &
			{
				color: palette(blue);
			}
		}

		&__tooltip
		{
			display: none;
			position: absolute;
			top: 100%;
			left: 50%;
			z-index: 100;
			transform: translateX(-50%);
			width: 240px;
			font-size: 12px;
			line-height: 1;
			text-align: left;
			text-transform: uppercase;
			margin-top: -1px;
			padding-top: 10px;

			&-items
			{
				display: table;
				min-width: 160px;
				@include extend(block-center);
				@include extend(bgc-pal--font);
				padding: 20px 24px;
				border-radius: 4px;
				box-shadow: rgba(0,0,0,0.25) 0 3px 8px;

				> *
				{
					display: block;

					&:not(:last-child)
					{
						margin-bottom: 20px;
					}

					&:hover
					{
						color: palette(blue);
					}
				}
			}

			#{$c}--open > &,
			#{$c}--open-on-hover:hover > &
			{
				display: block;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/ActionTooltip.vue